import i18n from "@/i18n.js";

export default [{ id: "wa3_representative", name: i18n.t("integrations.company.edit_region.attribute.wa3_representative") }];
